import { render, staticRenderFns } from "./PromotionSkeletonLoader.vue?vue&type=template&id=b986fbfc&scoped=true&"
import script from "./PromotionSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./PromotionSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./PromotionSkeletonLoader.vue?vue&type=style&index=0&id=b986fbfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b986fbfc",
  null
  
)

export default component.exports